import { render } from "./StafetRoundCounter.vue?vue&type=template&id=3de4b964"
import script from "./StafetRoundCounter.vue?vue&type=script&lang=js"
export * from "./StafetRoundCounter.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__